import { render } from "./MarketInquiry.vue?vue&type=template&id=3fffbca4&scoped=true&ts=true"
import script from "./MarketInquiry.vue?vue&type=script&lang=ts"
export * from "./MarketInquiry.vue?vue&type=script&lang=ts"

import "./MarketInquiry.vue?vue&type=style&index=0&id=3fffbca4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fffbca4"]])

export default __exports__